<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="线路历史故障"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj historyDiares" ref="articleRef">
      <h3>{{this.mlName}}<em>历史故障总数：{{this.total}}</em></h3>
      <van-pull-refresh v-model="isLoading"
          success-text="刷新成功"
          @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishText"
        @load="onLoad"
         :offset="10"
        :immediate-check='false'
      >
        <van-empty description="没有数据啦~" v-show="nodataShow"/>
          <!-- <p>刷新次数: {{ count }}</p> -->
          <ul>
            <li class="item xltj" v-for="(item,index) in list" :key="index">
              <h3> {{item.diaTypeName}}</h3>
              <p>{{item.diaRemark}}</p>
              <!-- <van-button  :color="item.fixedType == 0 ? '#F27A2B' :'#0BA57B'" plain size="mini"
                >{{item.fixedType == 0 ? '区间定位' : (item.fixedType==1?'精确定位':'')}}</van-button
              > -->
            </li>
          </ul>
      </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Col, Row, Button, NavBar, List, PullRefresh, Empty } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Col, Row, Button, NavBar, List, PullRefresh, Empty)

export default {
  name: 'mlineHistoryDiaresPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Empty.name]: Empty
  },
  data () {
    return {
      nodataShow: false,
      finishText: '没有更多了',
      mlineId: '',
      mlName: '', // 线路名称
      count: 0,
      isLoading: false,
      loading: false,
      finished: false,
      pageHeight: window.innerHeight,
      currentPage4: 1, // 当前页
      pagesize: 15, // 每页显示条数
      total: '', // 总条数
      totalPage: '', // 总页数
      offset: 50, // 滚动条与底部距离小于 offset 时触发load事件
      list: [ ],
      scrollTop: 0, // 在data属性中记录滚动的距离
      firstTO: false // 是否第一次进入该页面标记
    }
  },
  created () {
    // console.log('created')
    // console.log(this.$route.query.mlineId)
    this.currentPage4 = parseInt(localStorage.getItem('currentPage4') || 1) // 缓存里取到的都是字符串，根据实际情况转换。不让刚才11这种情况就来了。 以前没有缓存过分页，默认使用1.。.存储当前页,, 你是憨批吗？？？？这tm是设置还是取值？。。。 取值tm也不该在这儿取啊
    // this.firstTO = true
  },
  // 注意this.scrollTop是用户触发滚动事件获取的。
  activated () {
    // console.log('activated' + this.scrollTop)
    // console.log(this.$route.query.mlineId)
    this.$refs.articleRef.scrollTop = this.scrollTop
    this.list = []
    this.currentPage4 = 1
    this.getMlineHistoryDiares()
  },
  mounted () {
    // console.log('mounted')
    // console.log(this.$route.query.mlineId)
    this.mlineId = this.$route.query.mlineId// 传过来的线路id
    let article = this.$refs.articleRef // 获取到根节点
    // 绑定onscroll事件，只要滚动鼠标就会触发该事件，记录滚动的值
    article.addEventListener('scroll', this.pageScroll, true)
    if (!this.firstTO) {
      // console.log(this.firstTO)
      this.onRefresh() // 触发了created就不触发mounted
    }
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1)// 返回上一页面
    },
    pageScroll () {
      // console.log(this.$refs.articleRef.scrollTop) // 有用就怪了
      this.scrollTop = this.$refs.articleRef.scrollTop
    },
    onRefresh () {
      this.currentPage4 = 1
      this.list = []
      this.finished = false
      this.getMlineHistoryDiares()
    },
    getMlineHistoryDiares () {
      // console.log(this.$route.query.mlineId)
      localStorage.setItem('currentPage4', this.currentPage4)// 存储当前页
      this.util.post('/getMlineHistoryDiares', {
        mlineId: this.$route.query.mlineId, // 线路id
        currentPage: this.currentPage4, // 当前页
        pagesize: this.pagesize// 每页显示条数
      }).then(({ data }) => {
        if (data.code === 200) {
          // this.list = data.data.data.items
          this.mlName = data.data.mlName
          this.total = data.data.total
          this.totalPage = data.data.totalPage

          let infolist = data.data.list
          if (infolist.length > 0) {
            this.nodataShow = false
          }

          // 数据全部加载完成
          // 数据全部加载完成
          if (infolist) {
            // console.log(this.list)
            this.list = this.list.concat(infolist) // 这tm用的conact， 你说第一页和第二页的数据去哪儿了，不tm一直在列表里吗
            // 请在数据渲染完成后设置load状态。

            this.$nextTick(() => {
              this.loading = false// 取消正在加载状态
              this.isLoading = false
              // 不限制的concat， 人家刷新了，还在保留着以前的数据啊？
              // this.list = this.currentPage === 1 ? this.list : this.list.concat(infolist)
              // console.log(this.list)
              if (this.currentPage4 < this.totalPage) { // 判断接口返回数据量小于请求数据量，则表示此为最后一页
                this.finished = false
              } else {
                this.finished = true
                if (this.list.length === 0) {
                  this.nodataShow = true
                  this.finishText = ''
                } else {
                  this.nodataShow = false
                  this.finishText = '没有更多了'
                }
              }
            })
          } else {
            this.loading = false// 取消正在加载状态
            this.isLoading = false
            this.finished = true
          }
        } else {
          this.loading = false
          this.isLoading = false
          this.currentPage4 -= 1
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    onLoad () {
      if (!this.isLoading) {
        this.currentPage4 += 1
        this.getMlineHistoryDiares()
      }
    }

  },
  computed: {

  }

}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
  background-color: #0b7dec;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
.home{
  padding-top: 46px;
}
.historyDiares li p{
  padding: 10px 0 0;
}
</style>
